export default "__VITE_ASSET__de594dfb__"